import React from "react";
import { useController, useFormContext } from "react-hook-form";

import { FormControl, FormLabel, RadioGroup, RadioGroupProps } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";

export const RadioGroupField = ({ name, label, row = true, children, helperText }: Props) => {
  const { control } = useFormContext();
  const { field } = useController({ name, control });

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <RadioGroup {...field} row={row}>
        {children}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

interface Props extends RadioGroupProps {
  readonly label: string;
  readonly helperText?: string;
}
